import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { InjectionMode } from '../../types/skill';

interface SkillBadgeProps {
  name: string;
  status?: InjectionMode | 'skipped';
  onRemove?: () => void;
}

const STATUS_ICONS: Record<string, string> = {
  full: '✓',
  section: '◑',
  summary: '◐',
  auto: '✓',
  skipped: '⚠',
};

export const SkillBadge: React.FC<SkillBadgeProps> = ({ name, status, onRemove }) => {
  const { darkMode } = useTheme();

  const icon = status ? STATUS_ICONS[status] ?? '' : '';
  const isSkipped = status === 'skipped';

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
        isSkipped
          ? darkMode ? 'bg-amber-900/40 text-amber-300' : 'bg-amber-50 text-amber-700 border border-amber-200'
          : darkMode ? 'bg-blue-900/40 text-blue-300' : 'bg-blue-50 text-blue-700 border border-blue-200'
      }`}
    >
      {icon && <span>{icon}</span>}
      <span>{name}</span>
      {onRemove && (
        <button
          onClick={onRemove}
          className="ml-0.5 hover:opacity-70 transition-opacity"
          aria-label={`Remove ${name}`}
        >
          ×
        </button>
      )}
    </span>
  );
};
